import { IOffer } from '../../../types/offer';

export function isFlat(offer: IOffer): boolean {
  return offer.offerType === 'flat';
}
